<template>
  <footer>
    <div v-if="isLogin" class="footer">
      <ul class="footer-nav">
        <li v-for="(data, name, index) in this.pageList" :key="index">
          <router-link
            v-if="data.title !== 'CHIKYUJIN' && data.title !== 'FAQ' && data.title!== 'Community'"
            :to="{ name: 'Partner', query: { target: data.url } }"
            >{{ $t(data.localizing) }}</router-link
          >
          <router-link
            v-if="data.title == 'Community'"
            :to="{ name: data.url }"
            >{{ $t(data.localizing) }}</router-link
          >
          <a
            v-if="data.title == 'CHIKYUJIN' || data.title == 'FAQ'"
            :href="data.url"
            >{{ $t(data.localizing) }}</a
          >
        </li>
      </ul>
      <ul v-if="isLogin" class="footer-nav mt20">
        <li class="f-top noDot pl30">
          <a href="/">{{ $t("returnTop") }}</a>
        </li>
      </ul>
      <ul class="footer-link mt20">
        <li>
          <a href="https://3platz.jp/" target="_blank">Operating company</a>
        </li>
        <li>
          <a href="https://choy-san.jp/#inquiry" target="_blank">Contact</a>
        </li>
      </ul>
      <div class="downloadApp mt20">
        <span>{{ $t("downloadApplication") }}</span>
        <div class="downloadImage" v-if="i18n.locale == 'en'">
          <a
            href="https://apps.apple.com/jp/app/choy-san-%E8%AA%B0%E3%81%A7%E3%82%82%E3%83%97%E3%83%AA%E3%83%9A%E3%82%A4%E3%83%89%E3%82%AB%E3%83%BC%E3%83%89%E3%82%92%E4%BD%9C%E3%82%8C%E3%82%8B%E3%82%A2%E3%83%97%E3%83%AA/id1531999604"
            ><img
              src="@/assets/img/apple-store-en.png"
              alt="Download Application"
          /></a>
          <a href="https://play.google.com/store/apps/details?id=jp.choy_san"
            ><img
              src="@/assets/img/google-play-en.png"
              alt="Download Application"
          /></a>
        </div>
        <div class="downloadImage" v-if="i18n.locale == 'ja'">
          <a
            href="https://apps.apple.com/jp/app/choy-san-%E8%AA%B0%E3%81%A7%E3%82%82%E3%83%97%E3%83%AA%E3%83%9A%E3%82%A4%E3%83%89%E3%82%AB%E3%83%BC%E3%83%89%E3%82%92%E4%BD%9C%E3%82%8C%E3%82%8B%E3%82%A2%E3%83%97%E3%83%AA/id1531999604"
            ><img
              src="@/assets/img/apple-store-jp.png"
              alt="Download Application"
          /></a>
          <a href="https://play.google.com/store/apps/details?id=jp.choy_san"
            ><img
              src="@/assets/img/google-play-jp.png"
              alt="Download Application"
          /></a>
        </div>
      </div>
    </div>
    <div id="copyright">
      <p v-if="!isLogin" class="center mb20">
        <a class="text-white pb10" href="https://3platz.jp/" target="_blank"
          >Operating company</a
        >
        <a
          class="text-white"
          href="https://choy-san.jp/#inquiry"
          target="_blank"
          >Contact</a
        >
      </p>

      <p class="mt00">&copy; 2020-Choy-San</p>
    </div>
  </footer>
</template>

<script>
import links from "@/constants/LinksEnum";
import firebase from "firebase";
import i18n from "../i18n";

export default {
  name: "Footer",
  data() {
    return {
      i18n: i18n,
      db: firebase.firestore(),
      user: firebase.auth().currentUser,
      pageList: [],
      copyLinks: [],
    };
  },
  mixins: [links],
  props: {
    isLogin: Boolean,
    userPid: String,
  },
  watch: {
    userPid(pid) {
      this.pageList = [];
      for (let link of this.links) {
        if (link.url == "JobPartner" && pid == "0100000100") {
          // do nothing
        } else {
          this.pageList.push(link);
        }
      }
    },
  },
  created() {
    this.pageList = [];
    for (let link of this.links) {
      this.pageList.push(link);
    }
  },
  methods: {
    notAvailable() {
      window.alert(this.$t("downloadNotAvailable"));
    },
  },
};
</script>

<style scoped>
.footer {
  background-color: #f2f2f2;
}
</style>
